export class UpdateAccessPolicyRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "DataCatalogPolicyScope",
            "format": ""
        },
        {
            "name": "subjects",
            "baseName": "subjects",
            "type": "DataCatalogSubjectSet",
            "format": ""
        },
        {
            "name": "rowFilter",
            "baseName": "rowFilter",
            "type": "DataCatalogRowFilterPolicyBody",
            "format": ""
        },
        {
            "name": "masking",
            "baseName": "masking",
            "type": "DataCatalogMaskingPolicyBody",
            "format": ""
        },
        {
            "name": "validFrom",
            "baseName": "validFrom",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "expiresAt",
            "baseName": "expiresAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return UpdateAccessPolicyRequest.attributeTypeMap;
    }
    constructor() {
    }
}
